import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationModal = ({ showWindow, handleConfirm, selectId }) => {
  return (
    <div className={`fixed top-[-130px] left-0 right-0 bottom-0 z-10 w-full bg-black bg-opacity-25 flex justify-center items-center transition-all ${showWindow ? "block" : "hidden"}`}>
      <div className="bg-light rounded-md w-full px-10 py-6 max-w-[600px]">
        <p className="text-[#1A1A1A] font-bebas text-[32px] text-center pt-10">
          {showWindow === "yes" ? "Are You Sure Start A New Job!" : "Are You Sure Declined Job!"}
        </p>
        <div className="flex justify-center items-center gap-6 py-10">
          <button className="max-w-[100px] w-full h-10 rounded bg-accent text-white font-bebas text-xl" onClick={() => handleConfirm(false, 'no', selectId)}>
            No
          </button>
          {showWindow === "yes" ? (
            <button className="max-w-[100px] w-full h-10 rounded bg-primary text-white font-bebas text-xl" onClick={() => handleConfirm(false, 'yes', selectId)}>
              Yes
            </button>
          ) : (
            <button className="max-w-[100px] w-full h-10 rounded bg-primary text-white font-bebas text-xl" onClick={() => handleConfirm(false, 'no')}>
              Yes
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  showWindow: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  handleConfirm: PropTypes.func.isRequired,
  selectId: PropTypes.string.isRequired,
};

export default ConfirmationModal;